import { useEffect, useState } from "react";

// Keyed results cannot show an earlier pilot/airframe while a new request starts.
export function usePublicData<T>(key: string, load: () => Promise<T>) {
  const [attempt, retry] = useState(0);
  const [state, setState] = useState<{ key: string; data?: T; error?: string }>({ key: "" });
  useEffect(() => {
    let active = true;
    setState({ key });
    load().then(data => { if (active) setState({ key, data }); })
      .catch(error => { if (active) setState({ key, error: error instanceof Error ? error.message : "Unable to load data" }); });
    return () => { active = false; };
  }, [key, attempt]);
  const current = state.key === key ? state : { key };
  return { data: current.data, error: current.error, loading: !current.data && !current.error, refresh: () => retry(n => n + 1) };
}
